import { IValidationTypes } from "../types/IValidationTypes"

export const requiredValidator: IValidationTypes = {
    type: "REQUIRED",
    validator: (value, comparisonValue) => !(value == undefined || value == null || (typeof value == "string" && value.trim() == '')),
    message: `%fieldname% is a required field`
}

export const exactLengthValidator: IValidationTypes = {
    type: "EXACT_LENGTH",
    validator: (value, comparisonValue) => !(typeof value == "string" && comparisonValue.value && value.length == comparisonValue.value),
    message: `%fieldname% should be exactly %value% char(s) long`
}

export const minLengthValidator: IValidationTypes = {
    type: "MIN_LENGTH",
    validator: (value, comparisonValue) => !(typeof value == "string" && comparisonValue.value && value.length < comparisonValue.value),
    message: `%fieldname% should be atleast %value% char(s) long`
}

export const maxLengthValidator: IValidationTypes = {
    type: "MAX_LENGTH",
    validator: (value, comparisonValue) => !(typeof value == "string" && comparisonValue.value && value.length > comparisonValue.value),
    message: `%fieldname% should be atleast %value% char(s) long`
}

export const minValueValidator: IValidationTypes = {
    type: "MIN_VALUE",
    validator: (value, comparisonValue) => {
        let parsedValue = SystemValidator.parseAsOther(value, comparisonValue.value)
        if (parsedValue != null && parsedValue != undefined && comparisonValue.value && parsedValue < comparisonValue.value)
            return false;
        return true;
    } ,
    message: `%fieldname% should be greater than %value%`
}

export const maxValueValidator: IValidationTypes = {
    type: "MAX_VALUE",
    validator: (value, comparisonValue) => {
        let parsedValue = SystemValidator.parseAsOther(value, comparisonValue.value)
        if (parsedValue != null && parsedValue != undefined && comparisonValue.value && parsedValue > comparisonValue.value)
            return false;
        return true;
    },
    message: `%fieldname% should be less than  %value%`
}

export const Validators = { requiredValidator, exactLengthValidator, minLengthValidator, maxLengthValidator, minValueValidator, maxValueValidator}

export abstract class SystemValidator {
    static validators: IValidationTypes[] = [
        requiredValidator, exactLengthValidator, minLengthValidator, maxLengthValidator, minValueValidator, maxValueValidator
    ];

    static validateNew = (validationType: IValidationTypes, value: any, comparisonValue: any): boolean => validationType.validator ? validationType.validator(value, comparisonValue) : false;

    static validate = (validationType: IValidationTypes, value: string | number | Date | boolean | null | undefined) => {
        let parsedValue: any;

        switch (validationType.type) {

            case "REQUIRED":
                if ((value === undefined || value === null) || (typeof value === "string" && value.trim() === ''))
                    return false;
                break;

            case "MIN_LENGTH":
                if (typeof value == "string" && validationType.value && (value.length < validationType.value && value.trim() != ''))
                    return false;
                break;

            case "MAX_LENGTH":
                if (typeof value == "string" && validationType.value && (value.trim() != '' &&  value.length > validationType.value ))
                    return false;
                break;

            case "EXACT_LENGTH":
                if (typeof value == "string" && validationType.value && (value.trim() != '' &&  value.length == validationType.value))
                    return false;
                break;

            case "MIN_VALUE":
                parsedValue = SystemValidator.parseAsOther(value, validationType.value)
                if (parsedValue != null && parsedValue != undefined && validationType.value && parsedValue < validationType.value)
                    return false;
                break;

            case "MAX_VALUE":
                parsedValue = SystemValidator.parseAsOther(value, validationType.value)
                if (parsedValue != null && parsedValue != undefined && validationType.value && parsedValue > validationType.value)
                    return false;
                break;

            case "NUMBERS_ONLY":
                if (typeof value == "string") {
                    //let re = /^+-?[0-9]*$/;
                    //if (!re.test(String(value).toLowerCase())) return false;

                }
                break;
            case "EMAIL":
                if (typeof value == "string") {
                    let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    if (!re.test(String(value).toLowerCase())) return false;

                }
                break;

            case "CUSTOM":
            default:
                if (validationType.validator)
                    if (!validationType.validator(value, validationType.value))
                        return false;
                break;
        }

        return true
    }

    static parseAsOther(val1: any, val2: any): any {

        if (typeof val2 == "number") {
            if (typeof val1 == "string") {
                var objRegex = /(^-?\d\d*\.\d\d*$)|(^-?\.\d\d*$)/;
                if (objRegex.test(val1)) return parseFloat(val1);
                return parseInt(val1)
            }
        }

        if (typeof val2 == "object" && val2 != undefined && val2 != null && val2 instanceof Date) {
            if (typeof val1 == "string" && val1 != null && val2 != undefined) {
                return Date.parse(val1);
            }
        }

        return val1
    }

}

